import React, { ReactElement, ReactNode } from 'react';
import Helmet from 'react-helmet';

interface IProps {
  title?: string;
  keywords?: string;
  description?: string;
  siteName?: string;
  ogType?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogUrl?: string;
  ogImgUrl?: string;
  children?: ReactNode;
}

// A helper component that allows you to easily change the meta of a page
// such as the browser title or og meta image
export default function Meta({
  title = 'Stark: The suite of integrated accessibility tools',
  keywords = 'stark, accessibility, color-blind, contrast, check, plug-in, plugin, sketch, xd, adobe',
  description = 'The suite of integrated accessibility tools for your product design and development team • Making the world’s products accessible.',
  siteName = 'Stark',
  ogType = 'website',
  ogTitle = 'Stark: The suite of integrated accessibility tools for your product design and development team',
  ogDescription,
  ogUrl,
  ogImgUrl,
  children,
}: IProps): ReactElement {
  // Helmet doesn't support fragments for whatever reason so that's why this is split up like this
  return (
    <>
      <Helmet>
        <title>{title}</title>

        <meta name="keywords" content={keywords} />

        <meta name="author" content="Stark Lab, Inc" />

        <meta name="description" content={description} />

        <meta property="og:site_name" content={siteName} />

        <meta property="og:type" content={ogType} />

        <meta
          property="og:description"
          content={ogDescription ? ogDescription : description}
        />

        <meta name="twitter:description" content={ogDescription} />

        <meta name="twitter:site" content="@getstarkco" />
      </Helmet>

      {ogTitle && (
        <Helmet>
          <meta property="og:title" content={ogTitle} />

          <meta name="twitter:title" content={ogTitle} />
        </Helmet>
      )}

      {ogUrl && (
        <Helmet>
          <meta property="og:url" content={ogUrl} />

          <meta name="twitter:url" content={ogUrl} />
        </Helmet>
      )}

      {ogImgUrl && (
        <Helmet>
          <meta name="twitter:card" content="summary_large_image" />

          <meta property="og:image" content={ogImgUrl} />

          <meta name="twitter:image" content={ogImgUrl} />
        </Helmet>
      )}

      <Helmet>{children}</Helmet>
    </>
  );
}
